import { useState } from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { AlertTriangle, Trash2 } from "lucide-react";

// Kritik silme işlemleri için KIRMIZI onay diyaloğu.
// Kullanım: <ConfirmDelete trigger={<button>...</button>} title="..." description="..." onConfirm={fn} testid="pc-provider-del-<id>" />
export function ConfirmDelete({
  trigger, title = "Silmeyi onaylıyor musunuz?", description,
  confirmLabel = "Evet, Kalıcı Olarak Sil", onConfirm, testid,
}) {
  const [open, setOpen] = useState(false);
  const handle = async () => { try { await onConfirm?.(); } finally { setOpen(false); } };
  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>
      <AlertDialogContent data-testid={testid ? `${testid}-dialog` : undefined}>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-red-600">
            <AlertTriangle className="h-5 w-5" /> {title}
          </AlertDialogTitle>
          {description && <AlertDialogDescription className="text-slate-600">{description}</AlertDialogDescription>}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={testid ? `${testid}-cancel` : undefined}>Vazgeç</AlertDialogCancel>
          <AlertDialogAction data-testid={testid ? `${testid}-confirm` : undefined} onClick={handle}
            className="bg-red-600 text-white hover:bg-red-700 focus:ring-red-600">
            <Trash2 className="mr-1.5 h-4 w-4" /> {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default ConfirmDelete;
